module.exports = __webpack_public_path__ + "static/media/21.72f7f13f.wav";